import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Mail, Check, Sparkles, Sprout, BookOpen, Users, Building2 } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ComingSoon() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setEmail('');
    }, 1500);
  };
  const offerings = [{
    title: 'Workplace Anti-Fat Training',
    description: 'For organisations ready to address structural anti-fat bias and build truly inclusive cultures.',
    icon: <Building2 className="w-6 h-6" data-id="element-1933" />,
    color: 'bg-brand-orange',
    textColor: 'text-white'
  }, {
    title: 'Anti-Fat Bias Education',
    description: 'Practical, research-informed learning experiences that challenge internalized and systemic bias.',
    icon: <BookOpen className="w-6 h-6" data-id="element-1934" />,
    color: 'bg-brand-cyan',
    textColor: 'text-brand-navy'
  }, {
    title: 'Teacher Workshops',
    description: 'Facilitation-ready workshops for primary and secondary schools to support fat students.',
    icon: <Users className="w-6 h-6" data-id="element-1935" />,
    color: 'bg-brand-lime',
    textColor: 'text-brand-navy'
  }, {
    title: 'WAESTM',
    description: 'An interactive learning experience exploring the intersections of weight and systemic oppression.',
    icon: <Sparkles className="w-6 h-6" data-id="element-1936" />,
    color: 'bg-brand-navy',
    textColor: 'text-white',
    link: '/clusters/read-waestm',
    cta: 'Explore Now'
  }, {
    title: 'Fat Liberation 101',
    description: 'An accessible introduction for anyone beginning their journey into fat justice and liberation.',
    icon: <Sprout className="w-6 h-6" data-id="element-1937" />,
    color: 'bg-brand-cream',
    textColor: 'text-brand-navy',
    border: 'border-2 border-brand-navy'
  }];
  return <div className="min-h-screen bg-brand-cream text-brand-black font-sans" data-id="element-1938">
      {/* Navigation Placeholder (Minimal) */}
      <nav className="absolute top-0 left-0 right-0 p-6 z-50 flex justify-between items-center" data-id="element-1939">
        <div className="text-2xl font-black tracking-tighter text-brand-cream" data-id="element-1940">
          RE<span className="text-brand-orange" data-id="element-1941">GROWTH</span>
        </div>
        <Link to="/" className="text-brand-cream font-bold text-sm hover:text-brand-orange transition-colors" data-id="element-1942">
          Back to Main Site
        </Link>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex flex-col justify-center items-center bg-[#1C3A2E] overflow-hidden px-4 pt-20 pb-32" data-id="element-1943">
        {/* Organic Background Shapes */}
        <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-1944">
          <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-1945">
            <path d="M0 100 C 20 80 50 100 80 100 L 100 100 L 100 0 L 0 0 Z" fill="#2a4a38" data-id="element-1946" />
            <path d="M0 100 C 30 60 70 80 100 60 L 100 100 L 0 100 Z" fill="#1C3A2E" data-id="element-1947" />
          </svg>
        </div>

        {/* Animated Roots/Growth SVG */}
        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full max-w-4xl h-1/2 opacity-20 pointer-events-none" data-id="element-1948">
          <svg viewBox="0 0 400 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-1949">
            <motion.path d="M200,200 C200,150 150,100 150,50" fill="none" stroke="#F97316" strokeWidth="2" initial={{
            pathLength: 0
          }} animate={{
            pathLength: 1
          }} transition={{
            duration: 2,
            ease: 'easeOut'
          }} data-id="element-1950" />
            <motion.path d="M200,200 C200,160 250,120 250,60" fill="none" stroke="#D61C7F" strokeWidth="2" initial={{
            pathLength: 0
          }} animate={{
            pathLength: 1
          }} transition={{
            duration: 2.5,
            ease: 'easeOut',
            delay: 0.2
          }} data-id="element-1951" />
            <motion.path d="M200,200 C180,180 100,150 80,80" fill="none" stroke="#FFFBF5" strokeWidth="1" initial={{
            pathLength: 0
          }} animate={{
            pathLength: 1
          }} transition={{
            duration: 3,
            ease: 'easeOut',
            delay: 0.4
          }} data-id="element-1952" />
            <motion.path d="M200,200 C220,180 300,150 320,80" fill="none" stroke="#FFFBF5" strokeWidth="1" initial={{
            pathLength: 0
          }} animate={{
            pathLength: 1
          }} transition={{
            duration: 3,
            ease: 'easeOut',
            delay: 0.6
          }} data-id="element-1953" />
          </svg>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-1954">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-1955">
            <span className="inline-block px-4 py-1 mb-6 text-xs font-bold uppercase tracking-[0.2em] text-brand-orange border border-brand-orange rounded-full" data-id="element-1956">
              Coming Soon
            </span>
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-brand-cream mb-8 leading-[0.9] tracking-tight" data-id="element-1957">
              ReGrowth is <br data-id="element-1958" />
              <span className="text-brand-magenta" data-id="element-1959">Taking Root.</span>
            </h1>
            <p className="text-xl md:text-2xl text-brand-cream/80 max-w-2xl mx-auto mb-12 font-medium leading-relaxed" data-id="element-1960">
              We are building transformative learning experiences centered on
              fat liberation, anti-fat bias education, and radical community
              care.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1961">
              <Link to="/clusters/read-waestm" className="px-8 py-4 bg-brand-orange text-white font-bold text-lg rounded-full hover:bg-brand-magenta transition-colors flex items-center gap-2 group" data-id="element-1962">
                Explore WAESTM
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-1963" />
              </Link>
              <button onClick={() => document.getElementById('signup')?.scrollIntoView({
              behavior: 'smooth'
            })} className="px-8 py-4 bg-transparent border-2 border-brand-cream text-brand-cream font-bold text-lg rounded-full hover:bg-brand-cream hover:text-[#1C3A2E] transition-colors" data-id="element-1964">
                Join the Waitlist
              </button>
            </div>
          </motion.div>
        </div>
      </section>

      {/* What's Growing Section */}
      <section className="py-24 px-4 bg-brand-cream" data-id="element-1965">
        <div className="max-w-7xl mx-auto" data-id="element-1966">
          <div className="flex items-end justify-between mb-16 border-b-2 border-brand-navy/10 pb-8" data-id="element-1967">
            <h2 className="text-4xl md:text-5xl font-black text-brand-navy tracking-tight" data-id="element-1968">
              What's Growing
            </h2>
            <Sprout className="w-12 h-12 text-brand-lime" data-id="element-1969" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1970">
            {offerings.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`p-8 rounded-2xl ${item.color} ${item.textColor} ${item.border || ''} flex flex-col h-full min-h-[320px] relative overflow-hidden group hover:scale-[1.02] transition-transform duration-300`} data-id="element-1971">
                {/* Decorative circle */}
                <div className="absolute -right-12 -top-12 w-40 h-40 rounded-full bg-white/10 pointer-events-none" data-id="element-1972" />

                <div className="mb-6 p-3 bg-white/20 w-fit rounded-full backdrop-blur-sm" data-id="element-1973">
                  {item.icon}
                </div>

                <h3 className="text-2xl font-bold mb-4 leading-tight" data-id="element-1974">
                  {item.title}
                </h3>

                <p className={`text-lg leading-relaxed opacity-90 mb-8`} data-id="element-1975">
                  {item.description}
                </p>

                <div className="mt-auto" data-id="element-1976">
                  {item.link ? <Link to={item.link} className="inline-flex items-center font-bold border-b-2 border-current pb-1 hover:opacity-80 transition-opacity" data-id="element-1977">
                      {item.cta} <ArrowRight className="w-4 h-4 ml-2" data-id="element-1978" />
                    </Link> : <span className="inline-flex items-center text-sm font-bold uppercase tracking-wider opacity-60" data-id="element-1979">
                      Coming Soon
                    </span>}
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Why ReGrowth Section */}
      <section className="py-24 px-4 bg-brand-navy text-brand-cream relative overflow-hidden" data-id="element-1980">
        {/* Soil dot texture */}
        <div className="absolute inset-0 opacity-5 pointer-events-none" data-id="element-1981">
          <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-1982">
            <pattern id="soil" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-1983">
              <circle cx="2" cy="2" r="1" fill="#FFFBF5" data-id="element-1984" />
              <circle cx="20" cy="20" r="1" fill="#FFFBF5" data-id="element-1985" />
            </pattern>
            <rect width="100%" height="100%" fill="url(#soil)" data-id="element-1986" />
          </svg>
        </div>

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-1987">
          <div className="text-center mb-16" data-id="element-1988">
            <h2 className="text-4xl md:text-6xl font-black mb-8 text-brand-orange" data-id="element-1989">
              Why ReGrowth?
            </h2>
            <p className="text-xl md:text-2xl leading-relaxed font-medium text-brand-cream/90" data-id="element-1990">
              We are challenging anti-fat bias by building critical awareness
              and moving beyond shame-based narratives.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mt-16" data-id="element-1991">
            <div className="space-y-8" data-id="element-1992">
              <div className="flex gap-6" data-id="element-1993">
                <div className="w-12 h-12 rounded-full bg-brand-orange flex items-center justify-center flex-shrink-0 text-white font-bold text-xl" data-id="element-1994">
                  1
                </div>
                <div data-id="element-1995">
                  <h3 className="text-2xl font-bold mb-2 text-brand-cream" data-id="element-1996">
                    Beyond Compliance
                  </h3>
                  <p className="text-brand-cream/70 text-lg" data-id="element-1997">
                    We don't do tick-box exercises. We create deep, structural
                    understanding of how anti-fatness operates in workplaces and
                    schools.
                  </p>
                </div>
              </div>
              <div className="flex gap-6" data-id="element-1998">
                <div className="w-12 h-12 rounded-full bg-brand-magenta flex items-center justify-center flex-shrink-0 text-white font-bold text-xl" data-id="element-1999">
                  2
                </div>
                <div data-id="element-2000">
                  <h3 className="text-2xl font-bold mb-2 text-brand-cream" data-id="element-2001">
                    Rooted in Justice
                  </h3>
                  <p className="text-brand-cream/70 text-lg" data-id="element-2002">
                    Our work is intersectional and political. We connect fat
                    liberation to racial justice, disability justice, and
                    economic equity.
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-8" data-id="element-2003">
              <div className="flex gap-6" data-id="element-2004">
                <div className="w-12 h-12 rounded-full bg-brand-cyan flex items-center justify-center flex-shrink-0 text-brand-navy font-bold text-xl" data-id="element-2005">
                  3
                </div>
                <div data-id="element-2006">
                  <h3 className="text-2xl font-bold mb-2 text-brand-cream" data-id="element-2007">
                    Practical Change
                  </h3>
                  <p className="text-brand-cream/70 text-lg" data-id="element-2008">
                    Theory matters, but so does practice. We provide actionable
                    tools for educators, leaders, and individuals to interrupt
                    bias.
                  </p>
                </div>
              </div>
              <div className="flex gap-6" data-id="element-2009">
                <div className="w-12 h-12 rounded-full bg-brand-lime flex items-center justify-center flex-shrink-0 text-brand-navy font-bold text-xl" data-id="element-2010">
                  4
                </div>
                <div data-id="element-2011">
                  <h3 className="text-2xl font-bold mb-2 text-brand-cream" data-id="element-2012">
                    Community Led
                  </h3>
                  <p className="text-brand-cream/70 text-lg" data-id="element-2013">
                    We center the lived experiences of fat people. Nothing about
                    us without us.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer / Signup Section */}
      <section id="signup" className="py-24 px-4 bg-[#1C3A2E] text-brand-cream border-t border-brand-cream/10" data-id="element-2014">
        <div className="max-w-3xl mx-auto text-center" data-id="element-2015">
          <h2 className="text-3xl md:text-4xl font-black mb-6" data-id="element-2016">
            Be the first to know when we launch.
          </h2>
          <p className="text-lg text-brand-cream/70 mb-10" data-id="element-2017">
            Join our community to receive updates, early access to courses, and
            resources for your unlearning journey.
          </p>

          {isSubmitted ? <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="bg-brand-lime text-brand-navy p-8 rounded-2xl inline-flex flex-col items-center" data-id="element-2018">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-brand-lime mb-4" data-id="element-2019">
                <Check className="w-6 h-6" data-id="element-2020" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-2021">You're on the list!</h3>
              <p className="opacity-90" data-id="element-2022">Thank you for growing with us.</p>
            </motion.div> : <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto" data-id="element-2023">
              <input type="email" required placeholder="Enter your email address" value={email} onChange={e => setEmail(e.target.value)} className="flex-1 px-6 py-4 rounded-full bg-brand-cream text-brand-navy placeholder-brand-navy/50 font-medium focus:outline-none focus:ring-4 focus:ring-brand-orange" data-id="element-2024" />
              <button type="submit" disabled={isSubmitting} className="px-8 py-4 bg-brand-orange text-white font-bold rounded-full hover:bg-brand-magenta transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-2025">
                {isSubmitting ? 'Joining...' : <>
                    Join Waitlist <Mail className="w-5 h-5" data-id="element-2026" />
                  </>}
              </button>
            </form>}

          <div className="mt-16 pt-8 border-t border-brand-cream/10 flex flex-col md:flex-row justify-between items-center text-sm text-brand-cream/50" data-id="element-2027">
            <p data-id="element-2028">
              &copy; {new Date().getFullYear()} ReGrowth. All rights reserved.
            </p>
            <div className="flex gap-6 mt-4 md:mt-0" data-id="element-2029">
              <Link to="/policies/privacy" className="hover:text-brand-cream transition-colors" data-id="element-2030">
                Privacy Policy
              </Link>
              <Link to="/contact" className="hover:text-brand-cream transition-colors" data-id="element-2031">
                Contact
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
}